import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-payment-2",
  "use": "icon-payment-2-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"icon-payment-2\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M2.5 4.167c0-.46.373-.834.833-.834h13.334c.46 0 .833.373.833.834v2.5h-15v-2.5Zm0 4.166h15v7.5c0 .46-.373.834-.833.834H3.333a.833.833 0 0 1-.833-.834v-7.5ZM4.912 12.5a.833.833 0 1 0 0 1.667h3.86a.833.833 0 0 0 0-1.667h-3.86Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol